import { action, makeObservable, observable } from "mobx";
import CommonStore from "../../../../stores/CommonStore";
import ProductOrderProfitOverviewResponse from "../../../../model/productOrder/ProductOrderProfitOverviewResponse";
import { ShopOrderService } from "../../../../service/shop/ShopOrderService";

class ShopTabStore {
    public commonStore: CommonStore;
    public from: number;
    public to: number;

    public articleSummary: ProductOrderProfitOverviewResponse | undefined = undefined;
    public isLoading: boolean = false;

    constructor(commonStore: CommonStore, from: number, to: number) {
        this.commonStore = commonStore;
        this.from = from;
        this.to = to;

        makeObservable(this, {
            from: observable,
            to: observable,
            articleSummary: observable,
            isLoading: observable,
            
            setDateRange: action,
            loadShopOrders: action,
        });
    }

    public setDateRange(from: number, to: number) {
        this.from = from;
        this.to = to;
    }

    @action
    public async loadShopOrders() {
        try {
            this.isLoading = true;
            this.commonStore.setLoading();
            
            const response = await ShopOrderService.getProfitOverview(this.from, this.to);
            if (response.success) {
                this.articleSummary = response.data;
            }
            
            this.commonStore.removeLoading();
        } catch (error) {
            this.commonStore.removeLoading();
            console.error("Error al cargar órdenes de artículos:", error);
        } finally {
            this.isLoading = false;
        }
    }
}

export default ShopTabStore;
